const menu = {
    label: 'Gerenciar Landing Pages',
    icon: 'pi pi-fw pi-desktop',
    to: '/checkins/landingPages',
    rules: ['CHECKINS-EVENTOS-LP-00'],
};

export default menu;
